<template>
  <!-- Modal -->

  <div class="modal fade" id="modalImpugnacao" tabindex="-1" role="dialog" aria-labelledby="modalImpugnacaoTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Solicitação de Impugnação</h5>
          <a type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </a>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div class="d-flex align-items-center gap-2 mb-3">
                <span> Status: </span>
                <span class="ml-2" v-html="formatarStatus(status)"></span>
              </div>
              <p>
                Envie sua solicitação de impugnação para o leilão <b>"{{ getLeilao.nome }}"</b>, relatando o ocorrido e os motivos.
              </p>

              <label for="mensagem">Mensagem:</label>
              <textarea
                :disabled="status === 2 || status === 3"
                v-model="mensagem"
                class="form-control"
                rows="4"
                id="mensagem"
                placeholder="Digite sua mensagem"
              ></textarea>
              <div class="text-right">
                <small class="text-muted"> Caracteres: {{ mensagem.length }}/500 </small>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a
            v-if="getAuth && isCancelar && status !== 2 && status !== 3"
            href="javascript:void(0)"
            class="btn btn-danger rounded-pill text-uppercase"
            @click="cancelar"
          >
            Cancelar
          </a>
          <a v-if="getAuth && status !== 2 && status !== 3" href="javascript:void(0)" class="custom-button" @click="avancar"> Enviar </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters(['getLeilao', 'getAuth', 'getUsuarioInfo', 'getLote', 'getLeilaoImpugnado']),
  },
  data() {
    return {
      mensagem: '',
      resposta: '',
      status: 1,
      isCancelar: false,
      alertSuccess: false,
      alertError: false,
      alertMessage: '',
    };
  },
  async created() {
    await this.setLeilaoImpugnado({ leilaoId: this.getLote.leilaoId });
    if (this.getLeilaoImpugnado) {
      console.log('this.getLeilaoImpugnado', this.getLeilaoImpugnado);
      this.resposta = this.getLeilaoImpugnado.resposta;
      this.status = this.getLeilaoImpugnado.status;
      this.mensagem = this.getLeilaoImpugnado.mensagem;
      this.isCancelar = true;
    }
  },
  methods: {
    ...mapActions(['setCreateImpugnacao', 'setLeilaoImpugnado', 'setUpdateImpugnacao', 'setCancelarImpugnacao']),
    formatarStatus(status) {
      const statusText = this.getStatusText(status);
      const badgeClass = this.getStatusBadgeClass(status);
      return `<span style="font-size: 16px;" class="badge ${badgeClass}">${statusText}</span>`;
    },

    getStatusText(status) {
      if (status === 1) {
        return 'Pendente';
      } else if (status === 2) {
        return 'Deferido';
      } else if (status === 3) {
        return 'Indeferido';
      } else if (status === 4) {
        return 'Cancelado';
      }
      return '';
    },

    getStatusBadgeClass(status) {
      switch (status) {
        case 1: // Pendente
          return 'badge-warning';
        case 2: // Deferido
          return 'badge-success';
        case 3: // Indeferido
          return 'badge-danger';
        case 4: // Cancelado
          return 'badge-secondary';
        default:
          return 'badge-light';
      }
    },
    async avancar() {
      try {
        if (this.getLeilaoImpugnado) {
          await this.setUpdateImpugnacao({ id: this.getLeilaoImpugnado.impugnacaoId, leilaoId: this.getLote.leilaoId, mensagem: this.mensagem });
          this.alertMessage = 'Impugnação atualizada com sucesso!';
        } else {
          await this.setCreateImpugnacao({ leilaoId: this.getLote.leilaoId, mensagem: this.mensagem });
          this.alertMessage = 'Impugnação criada com sucesso!';
        }
        this.alertSuccess = true;
        this.$swal({
          title: 'Sucesso!',
          text: this.alertMessage,
          icon: 'success',
          confirmButtonText: 'Ok',
          preConfirm: async () => {
            this.isCancelar = true;
            await this.setLeilaoImpugnado({ leilaoId: this.getLote.leilaoId });
            this.fecharModal(); // Fechando o modal ao clicar em Ok
          },
        });
      } catch (error) {
        this.alertError = true;
        this.alertMessage = 'Erro ao processar a solicitação.';
        this.$swal({
          title: 'Erro!',
          text: this.alertMessage,
          icon: 'error',
          confirmButtonText: 'Ok',
          preConfirm: async () => {
            this.fecharModal(); // Fechando o modal ao clicar em Ok
          },
        });
      }
    },
    async cancelar() {
      console.log('this.getLeilaoImpugnado', this.getLeilaoImpugnado);
      await this.setCancelarImpugnacao({ id: this.getLeilaoImpugnado.impugnacaoId, leilaoId: this.getLote.leilaoId });
      this.alertSuccess = true;
      this.alertMessage = 'Impugnação cancelada com sucesso!';
      this.$swal({
        title: 'Sucesso!',
        text: this.alertMessage,
        icon: 'success',
        confirmButtonText: 'Ok',
        preConfirm: async () => {
          this.isCancelar = false;
          await this.$store.dispatch('clearLeilaoImpugnado');
          this.mensagem = '';
          this.fecharModal(); // Fechando o modal ao clicar em Ok
        },
      });
    },
    fecharModal() {
      document.querySelector('#modalImpugnacao [data-dismiss="modal"]').click();
    },
  },
};
</script>

<style scoped>
.modal-body {
  padding: 20px;
}
</style>
